export const WAREHOUSE_TYPES = [
  'MANUAL',
  'UNLIMITED'
];
